/**
 * @generated SignedSource<<e9305f052c9e0c3d6bcd56c81d5cb352>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsMobileModalContent_viewer$data = {
  readonly feedbackFormPhotoUpload: boolean | null;
  readonly paginatedFeedback: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly contemporaryTrackingString: string;
          readonly serviceId: string | null;
          readonly title: string | null;
        } | null;
        readonly publicNote: {
          readonly language?: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"Review_review">;
      } | null;
    } | null> | null;
    readonly metadata: {
      readonly aggregatedFeedback: {
        readonly overallExperience: {
          readonly mean: number | null;
        } | null;
      } | null;
    } | null;
    readonly numberOfPages: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_reviews">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_viewer">;
  readonly " $fragmentType": "SellerReviewsMobileModalContent_viewer";
};
export type SellerReviewsMobileModalContent_viewer$key = {
  readonly " $data"?: SellerReviewsMobileModalContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsMobileModalContent_viewer">;
};

import SellerReviewsMobileModalContentRefetchQuery_graphql from './SellerReviewsMobileModalContentRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "paginatedFeedback"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "orderByHighest"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "orderByLowest"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "orderByNewest"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": SellerReviewsMobileModalContentRefetchQuery_graphql
    }
  },
  "name": "SellerReviewsMobileModalContent_viewer",
  "selections": [
    {
      "alias": "feedbackFormPhotoUpload",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "feedbackFormPhotoUpload"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"feedbackFormPhotoUpload\")"
    },
    {
      "alias": "paginatedFeedback",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeInAppealProcess",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "excludePrivateItemReviews",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "orderByHighest",
          "variableName": "orderByHighest"
        },
        {
          "kind": "Variable",
          "name": "orderByLowest",
          "variableName": "orderByLowest"
        },
        {
          "kind": "Variable",
          "name": "orderByNewest",
          "variableName": "orderByNewest"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "OrderFeedbackMultipleQueryConnection",
      "kind": "LinkedField",
      "name": "__SellerReviewsMobileModalContent_paginatedFeedback_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderFeedbackMultipleQueryMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackType",
              "kind": "LinkedField",
              "name": "aggregatedFeedback",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AggregatedOrderFeedbackQuestionType",
                  "kind": "LinkedField",
                  "name": "overallExperience",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mean",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderFeedbackMultipleQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedback",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "publicNote",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "language",
                          "storageKey": null
                        }
                      ],
                      "type": "StandardQuestion",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Review_review"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SellerReviewsModalHeader_reviews"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerReviewsModalHeader_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a4542f92f63341441c33e3357272c49c";

export default node;
